import { GetProductState } from "api/queries";
import type { ResultOf, VariablesOf } from "gql.tada";
import type { FetchError } from "utils";
import { fetchData } from "utils";
import type { Unit } from "variables/enums";

type TopologyData = Required<
  Pick<
    VariablesOf<typeof GetProductState>["input"],
    "wizardType" | "dummyType" | "groupPosition"
  >
>;

export type GetProductStateInput = {
  nodeId: string;
  language: string;
  units: Unit;
  country: string;
  topologyData?: TopologyData;
};

export type FetchProductByNodeProps = {
  input: GetProductStateInput;
  onError: (error: FetchError) => void;
  onSuccess: (data: ResultOf<typeof GetProductState>) => void;
};

export const getProductState = ({
  input: { nodeId, language, units, country, topologyData },
  onError,
  onSuccess,
}: FetchProductByNodeProps) =>
  fetchData({
    query: GetProductState,
    variables: {
      input: {
        nodeId,
        languageCode: language,
        countryCode: country,
        resultUnitsSystem: units,
        requestUnitsSystem: units,
        ...(topologyData
          ? {
              wizardType: topologyData?.wizardType,
              dummyType: topologyData?.dummyType,
              groupPosition: topologyData?.groupPosition,
            }
          : {}),
      },
    },
    onSuccess: (data) => onSuccess(data),
    onError: (error) => onError(error),
  });
